import { Button, Modal } from "antd";
import { DocumentsSignModalButtonProps } from "../../../interfaces/props/DocumentsSignModalButtonProps";
import EcpAnimationBlock from "../../EcpAnimationBlock/EcpAnimationBlock";
import { useClientSignModalState } from "../model/useClientSignModalState";
import { SelectSignOneApp } from "./SelectSignOneApp/SelectSignOneApp";
import { ConfirmText } from "./ConfirmText/ConfirmText";
import { useGetApplicationDataQuery } from "../../../store/api/application.api";
import { useAppSelector } from "../../../store/reduxHooks";
import { SELECT_REQUEST_BANK_DOCUMENTS } from "../../../store/selectors/requestAppSelector";
import { useMemo } from "react";
import { SignDocItem } from "../../RequiringSigningDocuments/components/SuccessSignListDocs/items/SignDocItem/SignDocItem";

import classes from "./DocumentsSignModal.module.css";
import { DOCUMENTS_SIGN_IN_MODAL_TITLE_ENUM } from "../../../enums/documentsSignInModalTitleEnum";
import { DOCUMENTS_SIGN_IN_MODAL_TITLE } from "../../../constants/documentsSignInModalTitle";

// Модалка для подписания документов заявки, открывается по кнопке
export const DocumentsSignModalButton = ({
  applicationBankId,
  applicationId,
}: DocumentsSignModalButtonProps) => {
  const { refetch } = useGetApplicationDataQuery(applicationId);
  const documentsForSigning = useAppSelector(SELECT_REQUEST_BANK_DOCUMENTS);

  const onSuccess = () => {
    refetch();
  };
  const { modalView, isModalVisible, modalHandler } = useClientSignModalState(
    false,
    onSuccess,
  );

  const renderTitle = DOCUMENTS_SIGN_IN_MODAL_TITLE[modalView] || '';


  const renderSignInDocs = () => {
    return documentsForSigning.map(el => {
      return (
        <SignDocItem
          className={ classes.signDocItem }
          title={ el.name }
          subtitle={ el.type }
          key={ el.id }
        />
      )
    })
  };

  return (
    <>
      <Button onClick={modalHandler.open} type="primary">
        Подписать документы
      </Button>
      <Modal
        mask={false}
        title={false}
        open={isModalVisible}
        onCancel={modalHandler.cancel}
        footer={false}
        width={845}
        styles={{ body: { minHeight: 600 } }}
      >
        <div className={classes.wrapperModal}>
          <div className={classes.wrapperModalTitle}>
            <h2 className={classes.modalTitle}>{renderTitle}</h2>
          </div>
          {/* Страница выбора подписи */}
          {modalView === "selectSign" && (
            <SelectSignOneApp
              closeModal={modalHandler.cancel}
              startSigning={modalHandler.signDocumentsByAppId}
              setModalView={modalHandler.setView}
              applicationBankId={applicationBankId}
            />
          )}
          {/* Страница принятия пользовательского соглашения */}
          {modalView === "confirmText" && (
            <ConfirmText setModalView={modalHandler.setView} />
          )}
          {/* Страница процесса подписания с анимацией */}
          {modalView === "ecpAnimation" ? <EcpAnimationBlock /> : null}

          {modalView === "finish" && (
            <div className={classes.docsListWrapper}>
              <div className={classes.docsListItems}>
                {renderSignInDocs()}
              </div>

              <div className={classes.buttons}>
                <Button
                  size="large"
                  variant="solid"
                  color="primary"
                  className={classes.successBtnOk}
                  onClick={modalHandler.cancel}
                >
                  Ок
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};
